import { useDispatch } from 'react-redux';
import requests from '../../../../redux/reducer/requests';

export default function useDrawingResultCallbacks() {
  const dispatch = useDispatch();

  return {
    getDrawingResultWinners: (data) => dispatch(requests.thunks.getDrawingResultWinners(data)),
  };
}
